import styled from "styled-components";

export const Description = styled.div`
    padding: 0.8rem 1.6rem;
    border-radius: ${({ theme }) => theme.radius.default};
    color: ${({ theme }) => theme.color.supportNavy500};
    background-color: ${({ theme }) => theme.color.neutral50};
`;
